import { Flex, HStack, Text } from '@chakra-ui/react'
import { ReminderClockIcon } from '@components/icons'
import React from 'react'

interface SetReminderCardProps {
  client: any
  isOnboardingV2Enabled: boolean
  openSessionReminderModal: () => void
}

export const SetReminderCard = ({
  client,
  isOnboardingV2Enabled,
  openSessionReminderModal
}: SetReminderCardProps) => {
  if (client?.is_demo && isOnboardingV2Enabled) {
    return (
      <HStack
        as="button"
        data-id="set-reminder-btn"
        gap="8px"
        border="1px solid"
        borderColor="pale_gray"
        borderRadius="8px"
        p="16px"
        _hover={{
          bg: 'rgba(45, 84, 232, 0.04)'
        }}
        onClick={openSessionReminderModal}
      >
        <Flex
          bg="#D5DDFA"
          minW="44px"
          h="44px"
          borderRadius="8px"
          align="center"
          justify="center"
        >
          <ReminderClockIcon />
        </Flex>
        <Flex w="100%" direction="column" justify="center" align="flex-start">
          <Text>Ready for a real session?</Text>
          <Text color="primary">Set a reminder</Text>
        </Flex>
      </HStack>
    )
  }

  return null
}
